module.exports = __webpack_public_path__ + "static/media/execute_PP3.ecf26100.png";